import { Flex, useToast } from "@chakra-ui/react";
import { AudienceDTO } from "@intentsify/dto";
import { useMutation } from "@tanstack/react-query";
import { apiService, Endpoints } from "api";
import { ViewContainer } from "components";
import { useNavigate } from "react-router";
import { useScreen } from "utils";
import { CreateAudienceForm } from "../../components";
import { CatalogManagerScreenDefinition } from "../CatalogManager";
import { CreateAudienceDefinition } from "./CreateAudience.definition";

const CreateAudience = () => {
  useScreen(CreateAudienceDefinition);

  const { mutate, isLoading } = useCreateAudience();
  return (
    <ViewContainer>
      <Flex width="100%">
        <CreateAudienceForm
          mode="create"
          isLoading={isLoading}
          onCreate={mutate}
        />
      </Flex>
    </ViewContainer>
  );
};

const useCreateAudience = () => {
  const toast = useToast();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (params: AudienceDTO) => {
      await apiService.post(Endpoints.Audience.Create, params);
    },
    onSuccess: () => {
      toast({
        title: `Your request has been sent.`,
        status: "success",
      });
      navigate(CatalogManagerScreenDefinition.navigate());
    },
  });
};

export { CreateAudience };
